import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "title-div"
};
const _hoisted_2 = {
  key: 0,
  class: "src-div"
};
const _hoisted_3 = {
  style: {
    "margin-top": "1%"
  }
};
const _hoisted_4 = {
  class: "audit-div"
};
const _hoisted_5 = {
  class: "appr-content"
};
const _hoisted_6 = {
  class: "comm-content"
};
const _hoisted_7 = {
  class: "comm-content-header"
};
const _hoisted_8 = {
  class: "comm-content-add-div"
};
const _hoisted_9 = {
  class: "comm-add-div"
};
const _hoisted_10 = {
  key: 0,
  class: "comm-content-list"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  key: 1,
  class: "comm-content-null"
};
const _hoisted_13 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sensitive_words = _resolveComponent("sensitive-words");
  const _component_Check = _resolveComponent("Check");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_Close = _resolveComponent("Close");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createBlock(_component_el_dialog, {
    title: "素材审核",
    width: "30%",
    "show-close": false,
    "model-value": $props.visible,
    onClose: $setup.close
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_13, [_createVNode(_component_el_button, {
      onClick: $setup.close
    }, {
      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("取 消", -1)]))]),
      _: 1
    }, 8, ["onClick"]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      type: "primary",
      onClick: $setup.hanldeSave
    }, {
      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("保存", -1)]))]),
      _: 1
    }, 8, ["onClick"])), [[_directive_loading, _ctx.saveLoading]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      type: "primary",
      onClick: $setup.hanldeSubmit
    }, {
      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("提 交", -1)]))]),
      _: 1
    }, 8, ["onClick"])), [[_directive_loading, _ctx.loading]])])]),
    default: _withCtx(() => [$props.multiSrss && $props.multiSrss[0].srcTyp != '7' ? (_openBlock(), _createElementBlock("div", _hoisted_1, "当前审核的素材")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.multiSrss, (src, i) => {
      return _openBlock(), _createElementBlock("div", {
        key: i
      }, [src.srcTyp != '7' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", null, _toDisplayString(src.srcName), 1), _createElementVNode("div", _hoisted_3, _toDisplayString($setup.getSrcType(src.srcTyp)) + "/" + _toDisplayString(src.extension), 1)])) : _createCommentVNode("", true)]);
    }), 128)), _createVNode(_component_sensitive_words, {
      "sens-words-list": _ctx.sensWordsList
    }, null, 8, ["sens-words-list"]), _cache[17] || (_cache[17] = _createElementVNode("div", {
      class: "title-div",
      style: {
        "margin-top": "10px"
      }
    }, "请选择审核结果", -1)), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
      class: "audit-button",
      type: "success",
      plain: _ctx.audit.approveState != 1,
      onClick: _cache[0] || (_cache[0] = $event => _ctx.audit.approveState = 1)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_Check)]),
        _: 1
      }), _cache[7] || (_cache[7] = _createTextVNode(" 通过 ", -1))]),
      _: 1
    }, 8, ["plain"]), _createVNode(_component_el_button, {
      class: "audit-button",
      type: "warning",
      plain: _ctx.audit.approveState != 2,
      onClick: _cache[1] || (_cache[1] = $event => _ctx.audit.approveState = 2)
    }, {
      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("！保留意见", -1)]))]),
      _: 1
    }, 8, ["plain"]), _createVNode(_component_el_button, {
      class: "audit-button",
      type: "danger",
      plain: _ctx.audit.approveState != -1,
      onClick: _cache[2] || (_cache[2] = $event => _ctx.audit.approveState = -1)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_Close)]),
        _: 1
      }), _cache[9] || (_cache[9] = _createTextVNode(" 驳回 ", -1))]),
      _: 1
    }, 8, ["plain"])]), _cache[18] || (_cache[18] = _createElementVNode("div", {
      class: "title-div",
      style: {
        "margin-top": "10px"
      }
    }, "请输入审核备注内容", -1)), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_input, {
      type: "textarea",
      rows: 3,
      placeholder: "请输入审核备注内容",
      onInput: $setup.getCommContents,
      modelValue: _ctx.audit.aprroveContent,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.audit.aprroveContent = $event)
    }, null, 8, ["onInput", "modelValue"])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[11] || (_cache[11] = _createElementVNode("span", {
      class: "comm-content-title"
    }, "常用审核语", -1)), _createVNode(_component_el_button, {
      size: "small",
      type: "primary",
      onClick: _cache[4] || (_cache[4] = $event => _ctx.commContAddShow = true),
      link: ""
    }, {
      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("+新增", -1)]))]),
      _: 1
    })]), _withDirectives(_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_input, {
      type: "textarea",
      rows: 3,
      placeholder: "请输入常用审核语",
      modelValue: _ctx.newContent,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.newContent = $event)
    }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
      size: "small",
      onClick: _cache[6] || (_cache[6] = $event => _ctx.commContAddShow = false),
      plain: ""
    }, {
      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("取消", -1)]))]),
      _: 1
    }), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      size: "small",
      type: "primary",
      onClick: $setup.hanldeCommContAdd,
      plain: ""
    }, {
      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("提 交", -1)]))]),
      _: 1
    }, 8, ["onClick"])), [[_directive_loading, _ctx.loading]])])], 512), [[_vShow, _ctx.commContAddShow]]), _ctx.commContents && _ctx.commContents.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commContents, (c, i) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([i % 2 == 0 ? 'bk-color-0' : 'bk-color-1', 'comm-content-item']),
        key: i,
        onClick: $event => $setup.autoCompleteContent(c.content)
      }, _toDisplayString(c.content), 11, _hoisted_11);
    }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_12, " 暂无常用审核语 "))])]),
    _: 1
  }, 8, ["model-value", "onClose"]);
}